import { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';

import { HeadquarterContext } from 'context/HeadquarterContext';
import { Tabs } from '@mantine/core';
import { TabList } from 'primitives/TabList';
import EmbeddedAdmin from 'components/EmbeddedAdmin/EmbeddedAdmin';
import { LOCATION_PATH } from 'constants/path';

const VALID_TABS = ['edit-menu', 'edit-items', 'edit-schedule'] as const;

export default function LegacyMenu() {
  const { location } = useContext(HeadquarterContext);
  const navigate = useNavigate();
  const { tab } = useParams();

  // Redirect to restaurant root if invalid tab
  useEffect(() => {
    if (tab && !VALID_TABS.includes(tab as (typeof VALID_TABS)[number])) {
      void navigate(`${LOCATION_PATH}/${location.id}`, { replace: true });
    }
  }, [tab, location.id, navigate]);

  const currentTab = tab || 'edit-menu';

  const handleTabChange = (value: string | null) => {
    if (value) {
      void navigate(`${LOCATION_PATH}/${location.id}/menu/${value}`);
    }
  };

  const getEmbeddedAdminSrc = (tabContent: string) => {
    switch (tabContent) {
      case 'edit-menu':
        return `restaurant/${location.id}/menus`;
      case 'edit-items':
        return `restaurant/${location.id}/menu/items`;
      case 'edit-schedule':
        return `restaurant/${location.id}/menus/schedule`;
      default:
        return `restaurant/${location.id}/menus`;
    }
  };

  return (
    <Tabs value={currentTab} onChange={handleTabChange}>
      <TabList>
        <Tabs.Tab value="edit-menu" data-testid="EditMenuTab">
          Edit Menu
        </Tabs.Tab>
        <Tabs.Tab value="edit-items" data-testid="EditItemsTab">
          Edit Items
        </Tabs.Tab>
        <Tabs.Tab value="edit-schedule" data-testid="EditScheduleTab">
          Edit Schedule
        </Tabs.Tab>
      </TabList>

      <EmbeddedAdmin src={getEmbeddedAdminSrc(currentTab)} key={`${location.id}/${currentTab}`} />
    </Tabs>
  );
}
